jQuery('[data-container-toggle]').on('click', function () {
  jQuery(this).toggleClass('open').next('.sedcard-content').slideToggle();
})

jQuery('.author-item').on('mouseenter touchstart', function () {
  let $this = jQuery(this);
  let $tooltip = $this.find('.tooltip');
  let $window = jQuery(window);

  if ($window.width < 500) {
    $tooltip.addClass('open-center').removeClass('open-left');
  } else{
    $tooltip.removeClass('open-center').removeClass('open-left');
  }

  let d = $window.width() - ($this.offset().left + $this.width());
  if (d < 200) {
    $tooltip.addClass('open-left');
  } else {
    $tooltip.removeClass('open-left');
  }
})